import styled from 'styled-components';

export const SkinWrapper = styled.div`
  position: relative;
  margin: 14px;
  height: calc(100% - 28px);
  width: calc(100% - 28px);
  z-index: 1000;
`;
